import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'PayAsYouGo.header',
    defaultMessage: 'Pay-As-You-Go',
  },
  validatedJourneys: {
    id: 'PayAsYouGo.validatedJourneys',
    defaultMessage: 'Validated journeys',
  },
  fareSummary: {
    id: 'PayAsYouGo.fareSummary',
    defaultMessage: 'Fare summary',
  },
  pendingJourneys: {
    id: 'PayAsYouGo.pendingJourneys',
    defaultMessage: 'Pending journeys',
  },
  noPendingJourneys: {
    id: 'PayAsYouGo.noPendingJourneys',
    defaultMessage: 'No pending journeys to show',
  },
  noValidatedJourneys: {
    id: 'PayAsYouGo.noValidatedJourneys',
    defaultMessage: 'No validated journeys to show',
  },
  noFareSummaries: {
    id: 'PayAsYouGo.noFareSummaries',
    defaultMessage: 'No fares to show',
  },
  weeklyRollup: {
    id: 'PayAsYouGo.weeklyRollup',
    defaultMessage: 'Weekly roll-up',
  },
  disputes: {
    id: 'PayAsYouGo.disputes',
    defaultMessage: 'Disputes',
  },
});
